import { ApiError } from '../api/client'

// React Query's default retries every failed query three times. On a 429 that
// burns the caller's rate-limit budget: on 2026-10-23 one user's browsing
// turned /cards/images 429s into 130 requests a minute and every page's card
// art failed. So a 429 is never retried. Every other failure keeps the default
// three tries (a 401 during a token refresh recovers on the next try).
export function shouldRetryQuery(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status === 429) return false
  return failureCount < 3
}
